<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="grid-container">
    <el-row
      class="grid-content">
      <div class="name-section">
        <h1>Eventos recomendados</h1>
        <button
          type="text"
          class="btn-see-more"
          @click="goToSearch">Ver todos
        </button>
      </div>
      <carousel
        :navigation-enabled="true"
        :scroll-per-page="true"
        :per-page-custom="[[1920,4],[1440,4],[1280,4],[1200, 4],[1024,3],[940, 2], [600,1], [500,1], [400,1], [320,1]]"
        :navigation-prev-label="iconArrowLeft"
        :navigation-next-label="iconArrowRight"
        :pagination-size="8"
        class="slide-layout"
        pagination-active-color="#DE3745">
        <!--<slide
          v-for="item in event"
          :key="item.id">
          <card-all-dates
            :data="item"
            :category="item.category.parentId">
            <span
              v-for="(date, index) in eventPresentations"
              v-if="item.id === date.event.id"
              slot="mtNextDate"
              :key="index">
              <span>{{ dateFormat(date.startDate).format('L') }}</span>
            </span>
          </card-all-dates>
        </slide>-->
        <slide
          v-for="(item, index) in presentations"
          :key="index">
          <card-all-dates
            :data="item.event"
            :category="3">
            <span slot="mtNextDate">{{ dateFormat(item.startDate).format('L') }}</span>
          </card-all-dates>
        </slide>
      </carousel>
    </el-row>
    <br>
    <!-- <el-row
      class="grid-content">
      <div class="name-section">
        <h1>Fechas proximas</h1>
        <button
          type="text"
          class="btn-see-more">Ver todos
        </button>
      </div>
      <carousel
        :navigation-enabled="true"
        :scroll-per-page="true"
        :per-page-custom="[[1920,4],[1440,4],[1280,4],[1200, 4],[1024,3],[940, 2], [600,1], [500,1], [400,1], [320,1]]"
        :navigation-prev-label="iconArrowLeft"
        :navigation-next-label="iconArrowRight"
        :pagination-size="8"
        class="slide-layout"
        pagination-active-color="#DE3745">
        <slide
          v-for="(item, index) in presentations"
          :key="index">
          <card-unique-date
            :data="item.event"
            :id="item.id"
            :start-date="item.startDate">
            <div
              v-for="(icon, index) in event"
              v-if="icon.id === item.eventId"
              slot="icon"
              :key="index"
              class="icon-card">
              <i
                v-if="icon.category.parentId === 3"
                class="icon-music-icon music-category background-category"/>
              <i
                v-else-if="icon.category.parentId === 4"
                class="icon-sports-icon sports-category background-category"/>
              <i
                v-else-if="icon.category.parentId === 5"
                class="icon-arts-icon arts-category background-category"/>
              <i
                v-else-if="icon.category.parentId === 6"
                class="icon-kids-icon kids-category background-category "/>
              <i
                v-else-if="icon.category.parentId === 7"
                class="icon-special-icon special-category background-category"/>
            </div>
          </card-unique-date>
        </slide>
      </carousel>
    </el-row>-->
  </div>
</template>

<script>
import moment from 'moment'
import cardAllDates from '../_shared/mt-card-event'
import cardUniqueDate from '../_shared/mt-card-next-date'
export default {
  name: 'LayoutEvents',
  components: {
    cardAllDates, cardUniqueDate
  },
  data () {
    return {
      fullscreenLoading: false,
      iconArrowLeft: '<i class="icon-chevron-left">',
      iconArrowRight: '<i class="icon-chevron-right">',
      event: {},
      eventPresentations: {},
      presentationsCategory: [],
      dateFormat: moment,
      datesRange: []

    }
  },
  computed: {
    presentations () {
      let presentations = this.$store.getters['presentations/items']
      for (let i = 0; i < presentations.length; i++) {
        presentations[i].event.thumbImage = 'https://d1.netnet.mx/myticket/api/uploads/images/event/thumb/' + presentations[i].event.thumbImage
      }
      return presentations
    }
  },
  mounted () {
    this.fullscreenLoading = true
    Promise.all([
      this.$store.dispatch('events/get', {limit: 1000, with: 'category', sort: 'createdAt desc'}),
      this.$store.dispatch('presentations/query', {limit: 1000, sort: 'startDate asc', with: 'event'},
        {'filters[where][startDate][gte]': moment.utc().format('YYYY-MM-DD HH:mm:ss')})
    ]).then((response) => {
      this.event = response[0].data.items
      this.eventPresentations = response[1].data.items
      this.presentationsCategory = response[2].data.items

      for (let i = 0; i < this.eventPresentations.length; i++) {
        for (let j = 0; j < this.event.length; j++) {
          if (this.event[j].id === this.eventPresentations[i].eventId) {
            alert(this.event[j].id)
          }
        }
      }
    }).catch((e) => {
    }).finally(() => {
      this.fullscreenLoading = false
    })
  },
  methods: {
    goToSearch () {
      this.$router.push({name: 'Búsqueda'})
    }
  }
}
</script>

<style lang="scss" scoped>

    .name-section{
    border-bottom: 1px solid #E6E6E6;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 34px;
    h1{
      margin: 0;
      @include font-primary(14px, semibold);
      color: $carbon
    }
    .btn-see-more{
      border: none;
      color: $roseHeader;
      @include font-primary(12px, bold);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mt-home/mt-layout-events.vue